import { parseBoolean } from '@shared/boolean';
import { parseDateTime } from '@shared/date-time';
import { toEnumKey, toEnumValue, type EnumLike } from '@shared/enums';
import { parseNumber } from '@shared/numbers';
import { QueryParamsBase } from '@shared/routes';
import { DateTime } from 'luxon';
import type { AppQueryParamsReader } from './app-query.types';

/**
 * Application-level query params providing typed helpers.
 */
export class AppQueryParams extends QueryParamsBase implements AppQueryParamsReader {
  number(key: string): number | undefined {
    return parseNumber(this.value(key));
  }

  dateTime(key: string): DateTime | undefined {
    return parseDateTime(this.value(key));
  }

  boolean(key: string): boolean | undefined {
    return parseBoolean(this.value(key));
  }

  enumKey<T extends EnumLike>(enumObj: T, key: string): keyof T | undefined {
    return toEnumKey(enumObj, this.value(key), { convert: true, ignoreCase: true });
  }

  enumValue<T extends EnumLike>(enumObj: T, key: string): T[keyof T] | undefined {
    return toEnumValue(enumObj, this.value(key), { convert: true, ignoreCase: true });
  }
}
